// Small shield-and-crosshair mark shown before the FuzzScan name. Same artwork as /favicon.svg.
export default function LogoMark({ size = 28, style = {} }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" style={{ flex: 'none', display: 'block', ...style }}>
      <rect width="32" height="32" rx="8" fill="#0a0f1a" />
      <circle cx="16" cy="16" r="11.5" stroke="#22c55e" strokeWidth="1" strokeOpacity="0.45" />
      <path d="M16 5.5L23 8.3V14.2C23 18.8 20 23 16 24.8C12 23 9 18.8 9 14.2V8.3L16 5.5Z" fill="#22c55e" fillOpacity="0.15" stroke="#22c55e" strokeWidth="1.4" strokeLinejoin="round" />
      <line x1="16" y1="10" x2="16" y2="20.5" stroke="#22c55e" strokeWidth="1.2" strokeLinecap="round" />
      <line x1="11" y1="15" x2="21" y2="15" stroke="#22c55e" strokeWidth="1.2" strokeLinecap="round" />
      <circle cx="16" cy="15" r="2" fill="#22c55e" />
    </svg>
  );
}
